module.exports = __webpack_public_path__ + "img/171.8f4d12a4.jpg";